import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useMutation } from '@apollo/react-hooks';
import AuthenticateMutation from './authenticate.gql';
export var didSucceed = function didSucceed(data) {
  return !!(data === null || data === void 0 ? void 0 : data.token);
};
export var requiresChallenge = function requiresChallenge(data) {
  return Boolean(data === null || data === void 0 ? void 0 : data.id) && !Boolean(data === null || data === void 0 ? void 0 : data.token);
};

var useAuthenticateMutation = function useAuthenticateMutation() {
  var _useMutation = useMutation(AuthenticateMutation),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      fireMutation = _useMutation2[0],
      loading = _useMutation2[1].loading;

  var authenticateMutation = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _result$data;

      var email,
          password,
          result,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              email = _args.length > 0 && _args[0] !== undefined ? _args[0] : '';
              password = _args.length > 1 && _args[1] !== undefined ? _args[1] : '';
              _context.next = 4;
              return fireMutation({
                variables: {
                  input: {
                    email: email,
                    password: password,
                    udid: 'internal-login'
                  }
                }
              });

            case 4:
              result = _context.sent;
              return _context.abrupt("return", result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.authenticate);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function authenticateMutation() {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    authenticateMutation: authenticateMutation,
    loading: loading
  };
};

export { useAuthenticateMutation };